var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.611,
    height: 24.671,
    viewBox: "0 0 17.611 24.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wifi_icon",
    "data-name": "wifi icon",
    transform: "translate(17.611) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.33,0A18.193,18.193,0,0,0,.14,4.859a.439.439,0,0,0-.017.627L1.593,7.022a.452.452,0,0,0,.638.017,14.785,14.785,0,0,1,10.1-3.946,14.785,14.785,0,0,1,10.1,3.946.452.452,0,0,0,.638-.017l1.469-1.535a.439.439,0,0,0-.017-.627A18.242,18.242,0,0,0,12.33,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.673,11.139l-2.939-2.9a.44.44,0,0,1-.011-.616,4.507,4.507,0,0,1,6.538,0,.439.439,0,0,1-.01.616l-2.939,2.9a.451.451,0,0,1-.638,0Zm5.976-5.916a8.561,8.561,0,0,0-11.325,0,.452.452,0,0,1-.617-.016L.133,3.649A.45.45,0,0,1,.139,3,11.738,11.738,0,0,1,15.824,3a.44.44,0,0,1,.016.644L14.266,5.206a.459.459,0,0,1-.32.13A.441.441,0,0,1,13.649,5.223Z",
    transform: "translate(4.338 6.34)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi-icon.42fbcbdf0dd3b71718838892034d8f73.svg";
export { ForwardRef as ReactComponent };